import gsap from 'gsap';
import EventDispatcher from '../../common/EventDispatcher';
import { Global } from '../../common/global';

export default class Score {
  constructor() {
    document
      .querySelector('#scoreScr #replayBtn')
      .addEventListener('click', this.replayGame.bind(this));
  }
  init() {
    this.isVisible = false;
    this.proceeded = false;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
      case 'hide_home':
        this.hideScreen(data['message']['data']);
        break;
    }
  }
  hideScreen(data) {
    if (!this.isVisible) return;

    if (data && data['screenKey'] !== 'Score') return false;

    this.isVisible = false;

    document.querySelector('#scoreScr').classList.remove('active2');
    gsap.delayedCall(0.5, () => {
      document.querySelector('#scoreScr').classList.remove('active');
    });
  }
  showScreen(data) {
    if (data['screenKey'] !== 'Score') return false;

    this.isVisible = true;
    this.proceeded = false;

    // if (Global.scoreSubmitted) {
    //   document.querySelector('#submitBtn').classList.add('disabled');
    // } else {
    //   document.querySelector('#submitBtn').classList.remove('disabled');
    // }
    document.querySelector('#scoreScr').classList.add('active');

    document.querySelector('#scoreScr .score_card .label').innerHTML =
      `${Global.scoreTotal < 10 ? '0' : ''}${Global.scoreTotal}`;
    gsap.delayedCall(0.5, () => {
      document.querySelector('#scoreScr').classList.add('active2');
    });
    // gsap.delayedCall(0.2, this.animate.bind(this));
  }
  animate() {
    this.frameDate = {
      value: 1,
    };
    document
      .querySelector('#homeScr .title')
      .classList.remove(`title${this.lastVal}`);
    this.lastVal = 0;
    this.introTwn = gsap.to(this.frameDate, {
      value: 44, // Animates from 10 to 0
      duration: 2, // 10 seconds
      ease: 'none',
      delay: 0,
      onUpdate: function () {
        if (this.lastVal != Math.floor(this.frameDate.value)) {
          document
            .querySelector('#homeScr .title')
            .classList.remove(`title${this.lastVal}`);

          this.lastVal = Math.floor(this.frameDate.value);
          document
            .querySelector('#homeScr .title')
            .classList.add(`title${this.lastVal}`);
        }
      }.bind(this),
      onComplete: () => {
        // document.querySelector('.kick_icon').classList.add(`active`);
        // document.querySelector('.intro').classList.add(`active`);
        Global.canSwipe = true;
      },
    });
  }
  replayGame() {
    if (!this.isVisible || this.proceeded) return;

    this.proceeded = true;
    console.log('replayGame');
    this.events.dispatchEvent({
      type: 'SOUND_EVENTS',
      message: {
        event_type: 'play_sound',
        data: {
          sndKey: 'click',
        },
      },
    });
    this.hideScreen();
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'replay_game',
        data: {},
      },
    });
    //
  }
  submitScore() {
    if (!this.isVisible) return;

    this.hideScreen();
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'show_screen',
        data: {
          screenKey: 'Register',
        },
      },
    });
  }
}
